module.exports = __webpack_public_path__ + "public/images/history-background-pattern.c32da55595bed475fbe27e8c63bdbb9f.svg";